import styled from 'styled-components';

export const StyledAcceptPolicyPublishVoice = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
  .select-retention-days {
    width: 50%;
  }
`;
